const loginAuthControllerName = "/login";
const forgotAuthControllerName = "/forgot-password";
const eventControllerName = "/event";
const servicesControllerName = "/admin/services";
const adminEventControllerName = "/admin/event";
const userControllerName = "/admin/user-management";
const locationController = "/accepted";
const verifyOTP = "/verify-otp";
const resetPassword = "/reset-password";
const adminCategories = "/admin/categories";
const getAdminCategories = "/categories";
const vendorControllerName = "/vendor";
const eventTicketsListing = "/admin/event-ticket";
const serviceTicketsListing = "/Admin/purchased/service";
const bookingTicketsListing = "/Admin/purchased/Booking";
const ticketDelete = "/admin/event-ticket";
const purchaseTicket = "admin/event-ticket/purchase-ticket";
const ticketStates = "/admin/event-ticket/states";
const eventDelete = "/admin/event";
const adminEmail = "/me";
const adminCommission = "/admin/user-management/get-commission";
const addAdminCommission = "/admin/user-management/set-commission";
const bookingListing = "/admin/bookings";
const profileData = "/admin/settings/profile";
const updateProfile = "/admin/settings/profile";
const bookingID = "admin/booking";
const addBooking = "admin/bookings";
const addBookingTable = "admin/bookings/tables";
const updateBooking = "admin/bookings";
const addContactInfo = "admin/settings/contact/info";
const contactInfoTable = "admin/settings/contact/info";
const artistController = "artist";
const reminderController = "reminder";
const vendorTicketsListing = "vendor/ticket-listing";
const adminEventParticipants = "/event/participants";
const bookingEarning = "admin/booking/earning";
const statsApi = "common-api";
const adminNotifications = "/admin/notification";
const registerAuthControllerName = "/register";
const checkVendor = "/auth/check/vendor";
const updateProfileInfo = "/vendor/{id}";
const stripeLogin = "/stripe/login-link";
const stripeAuthorize = "/stripe/oauth/authorize";
const approveVendor = "/admin/user-management/vendor/update/status";
const vendorEarningStats = "/common-api/earning/stats";
const contactUs = "/common-api/contact-us";
const vendorEarningWithdraw = "/vendor/withdrawAvailableAmount";
const mediaController = "/media";
const language = "/languages";
const currency = "/currency";
const purchasedBookings = "/purchase-booking/purchased";
const markedAsPayed = "/purchase-booking/markedAsPayed";
const purchaseService = "/purchased/service/purchase/allServicesPurchase";

export const SERVICE_CONFIG_URLS = {
    AUTH: {
        LOGIN: `${loginAuthControllerName}`,
        FORGET_PASSWORD: `${forgotAuthControllerName}`,
        VERIFY_OTP: `${verifyOTP}`,
        RESET_PASSWORD: `${resetPassword}`,
        REGISTER: `${registerAuthControllerName}`,
        CURRENT_PASSWORD: `${checkVendor}`,
        UPDATE_PROFILE_INFO: `${updateProfileInfo}`,
        GET_PROFILE_INFO: `${adminEmail}`,
        GET_STRIPE_LOGIN: `${stripeLogin}`,
        STRIPE_AUTHORIZE: `${stripeAuthorize}`,
        GET_BANK_DETAIL: `/get/user/bank/account/details`,
        UPDATE_BANK_DETAILS: `/user/bank/account/details`,
        GET_BANK_DETAIL_BY_ID: (id) => `/get/user/bank/account/details/${id}`,
    },

    MEDIA: {
        INIT: `${mediaController}/upload/init`,
        FINALIZE: `${mediaController}/upload/finalize`,
    },
    DASHBOARD: {
        STATS: `${statsApi}/dashboard/stats`,
    },
    CONTACTUS: {
        CONTACT: contactUs,
    },
    USER: {
        USER_LISTING: `${userControllerName}/`,
        USER_BY_ID: `${userControllerName}/{id}`,
        DELETE_USER_BY_ID: `${userControllerName}/delete/soft/{id}`,
        ADMIN_NOTIFICATIONS: `${adminNotifications}`,
    },
    EVENT: {
        EVENT_LISTING: `${eventControllerName}`,
        BY_ID: `${eventControllerName}/{id}`,
        EVENT_DELETE: `${eventDelete}/{id}`,
        EVENT_TICKET_CHANGE_STATUS: `${eventControllerName}/tickets/change-status/{id}`,
        DOWNLOAD_ALL_QR: (id) => `${ticketDelete}/download/event/qr/${id}`,
    },
    SERVICES: {
        ADD_SERVICE: `${servicesControllerName}`,
        SERVICES_LISTING: `${servicesControllerName}`,
        BY_ID: `${servicesControllerName}/{id}`,
        SERVICE_DELETE: `${servicesControllerName}/{id}`,
        SERVICE_DELETE_IMAGE: `${servicesControllerName}/images`,
        EDIT_SERVICE_BY_ID: `${servicesControllerName}/{id}`,
        SERVICE_EARNING_ADMIN: `${servicesControllerName}/earning/{id}`,
        SERVICE_EARNING: `${servicesControllerName}/{id}/earning/{id2}`,
        SERVICE_ORDER_LISTING: `${serviceTicketsListing}`,
    },
    ADMIN_EVENT: {
        ADD_EVENT: `${adminEventControllerName}`,
        EDIT_EVENT_BY_ID: `${adminEventControllerName}/{id}`,
        DELETE_EVENT_BY_ID: `${adminEventControllerName}/{id}`,
        EVENT_EARNING: `${adminEventControllerName}/earning/{id}`,
        ADD_IMAGES: `${adminEventControllerName}/upload/images`,
        DELETE_IMAGES: `${adminEventControllerName}/images`,
        EVENT_ATTENDEES: `${adminEventParticipants}?eventId={id}`,
        EVENT_ATTENDEES_TICKET_QR_LIST: `${ticketDelete}/ticket/count/{eventId}/{userId}`,
        POST_EVENT_ATTENDEES_TICKET_QR_LIST: `${ticketDelete}/map/qrcode/{eventId}`,
        GET_EVENT_ATTENDEES_DETAIL_QR: `/admin/event-ticket/get-attendee-details/qr/{eventId}/{qrCode}`,
        DELETE_EVENT_QR_FROM_MAPPING: `/admin/event-ticket/qr/delete`,
        CREATE_EVENT_PURCHASE: `/admin/event-ticket/event/purchase`,
        UPDATE_EVENT_PURCHASE: `/admin/event-ticket/update/event/purchase`,
        GET_EVENT_PURCHASE_BY_ID: (eventPurchaseId) =>
            `/admin/event-ticket/get/event/purchase/${eventPurchaseId}`,
        GET_EVENT_PURCHASE: (eventId) =>
            `/admin/event-ticket/get/event/purchases/${eventId}`,
        EVENT_PURCHASE_OTP_VERIFICATION: `/admin/event-ticket/event/purchases/verify/otp`,
    },
    CATEGORY: {
        ADMIN_CATEGORIES: `${adminCategories}`,
        GET_ADMIN_CATEGORIES: `${getAdminCategories}`,
        DELETE_CATEGORIES: `${adminCategories}/{id}`,
        ADMIN_EMAIL: `${adminEmail}/`,
        ADMIN_COMMISSION: `${adminCommission}/`,
        ADD_ADMIN_COMMISSION: `${addAdminCommission}/`,
    },
    VENDOR: {
        GET_VENDORS: `${vendorControllerName}`,
        ADD_VENDORS: `${vendorControllerName}`,
        DELETE_VENDOR: `${vendorControllerName}/{id}`,
        GET_VENDOR: `${vendorControllerName}/{id}`,
        GET_VENDOR_TICKETS_LISTING: `${vendorTicketsListing}/{id}`,
        GET_VENDOR_TICKETS_LISTING_V2: `/vendor/earning/all`,
        // GET_VENDOR_TICKETS_LISTING_SEARCH: `${vendorTicketsListing}`,
        APPROVE_VENDOR: `${approveVendor}`,
        GET_VENDOR_EARNING_STATS: `${vendorEarningStats}`,
        VENDOR_EARNING_WITHDRAW: `${vendorEarningWithdraw}`,
        CREATE_PAYOUT: "/admin/event-ticket/vendor/payout",
        GET_PAYOUT: "/admin/event-ticket/payout/all",
        PAYNOW_PAYOUT: (id) => `/admin/event-ticket/vendor/payout/paynow/${id}`,
        REJECT_PAYOUT: (id) => `/admin/event-ticket/vendor/payout/reject/${id}`,
        TOGGLE_STATUS: (id) => `/vendor/toggle-status/${id}`,
        GET_BY_PAYOUT_ID: (payoutId, vendorId) =>
            `/admin/event-ticket/vendor/payout/${payoutId}/${vendorId}`,

        GET_PURCHASED_SERVICES: `${purchaseService}`,
    },
    TICKETS: {
        EVENT_TICKETS_LISTING: `${eventTicketsListing}`,
        SERVICE_TICKETS_LISTING: `${serviceTicketsListing}`,
        BOOKING_TICKETS_LISTING: `${bookingTicketsListing}`,
        TICKET_DELETE: `${ticketDelete}/{id}`,
        PURCHASE_TICKET: `${purchaseTicket}`,
        TICKET_STATES: `${ticketStates}/{id}`,
    },
    QR_CODE: {
        GET_QR_LISTING: (id) =>
            `${eventTicketsListing}/get-event-qr-list/${id}`,
    },
    BOOKING: {
        BOOKING_LISTING: `${bookingListing}`,
        BY_ID: `${bookingID}/{id}`,
        DELETE_BOOKING_BY_ID: `${bookingID}/{id}`,
        ADD_BOOKING: `${addBooking}`,
        ADD_BOOKING_TABLE: `${addBookingTable}`,
        UPDATE_BOOKING: `${updateBooking}/{id}`,
        CONTACT_INFO_TABLE: `${updateBooking}/{id}`,
        BOOKING_DELETE_IMAGE: `${bookingID}/images`,
        UPDATE_BOOKING_TABLE: `${updateBooking}/tables/{id}`,
        BOOKING_EARNING: `${bookingEarning}/{id}`,
        BOOKING_ORDER_LISTING: `${bookingTicketsListing}`,
        PURCHASED_BOOKINGS: `${purchasedBookings}/{id}`,
        MARK_AS_PAID: `${markedAsPayed}/{id}`,
    },
    PROFILE: {
        PROFILE_DATA: `${profileData}`,
        UPDATE_PROFILE: `${updateProfile}`,
        COUNTRIES_LIST: `${locationController}/countries`,
        CITIES_LIST: `${locationController}/cities`,
        STATE_LIST: `${locationController}/states`,
        EDIT_PROFILE: `${userControllerName}/update`,
    },
    CONTACT_INFO: {
        ADD_CONTACT_INFO: `${contactInfoTable}`,
        CONTACT_INFO_TABLE: `${contactInfoTable}`,
        DELETE_CONTACT_INFO: `${contactInfoTable}/{id}`,
    },
    ARTIST: {
        ARTIST: `${artistController}`,
        ARTIST_BY_ID: `${artistController}/{id}`,
        ARTIST_DELETE_IMAGE: `${artistController}/images`,
    },
    REMINDER: {
        REMINDER: `${reminderController}`,
        REMINDER_BY_ID: `${reminderController}/{id}`,
    },
    LANGUAGE: {
        GET_LANGUAGES: `${language}`,
        ADD_LANGUAGE: `${language}`,
        DELETE_LANGUAGE: `${language}/{id}`,
        UPDATE_LANGUAGE: `${language}/{id}`,
    },
    CURRENCY: {
        GET_CURRENCIES: `${currency}`,
        GET_CURRENCY: `${currency}/{id}`,
        ADD_CURRENCY: `${currency}`,
        DELETE_CURRENCY: `${currency}/{id}`,
        UPDATE_CURRENCY: `${currency}/{id}`,
    },
};

export const multiFormDataHeader = {
    headers: {
        "Content-Type": "multipart/form-data",
        Accept: "multipart/form-data",
    },
};
